import { MessagesTemplate } from "../../templates/MessagesTemplate/MessagesTemplate";

export const MessagesPage = () => {
  return <MessagesTemplate />;
};
